import { useEffect, useState } from "react";
import Navbar from "../../Navbar/Navbar";
import './login.css';
// import { Fade } from 'react-awesome-reveal';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { dispatchLogin } from "../../../redux/actions/authActions.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { appAddress } from "../../../App.js";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n.js";

const initialState = {
  email: '',
  password: '',
   err: '',
  success: ''
};

export default function Login() {
  const {t} = useTranslation()
  const [user, setUser] = useState(initialState); 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { email, password } = user;

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);

    const rootElement = document.getElementById('root');
    if (savedLanguage === 'fa' || savedLanguage === 'ar') {
      rootElement.classList.remove('ltr', 'text-left');
      rootElement.classList.add('rtl', 'text-right');
    } else {
      rootElement.classList.remove('rtl', 'text-right');
      rootElement.classList.add('ltr', 'text-left');
    }
  }, []);

  const handleChangeInput = e => {
    const {name, value} = e.target
    setUser({...user, [name]:value, err:'', success:''})
  }

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const res = await axios.post(`${appAddress}/user/login`,{ email, password }, { withCredentials: true })
      // const res = await axios.post('/user/login',{ email, password }, { withCredentials: true })

      
      setUser({...user, err: '', success: res.data.msg})
      localStorage.setItem('firstLogin', true)
      dispatch(dispatchLogin())
      
      toast.success(res.data.msg, {
          position:"bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      
      navigate('/dashboard');
      

    } catch (err) {
      toast.error(err.response.data.msg, {
          position:"bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      
      err.response.msg && setUser({...user, err: err.response.data.msg, success:''})
    }
  }


  return (
    <>
      <div className="w-5/6 h-5/6 mb-8 tablet:w-5/6 laptop:w-5/6 laptop:h-5/6 desktop:w-5/6 desktop:h-[700px] desktopXL:w-5/6 desktopXL:h-[890px] flex flex-col tablet:flex-col m-auto">
        <header className="sticky w-full">
          <div className="ltr">
            <Navbar />
          </div>
        </header>

        <div className="flex items-center justify-center h-full lbgImage">
        <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl
              pauseOnFocusLoss
              draggable
              pauseOnHover/>
          <div className="flex flex-col justify-center items-center w-[500px] h-[400px] m-auto">
            {/* <Fade> */}
              <form onSubmit={handleSubmit} className="flex flex-col items-center justify-center w-full h-full lbgBlur mt-7">
                {/* <Fade bottom> */}
                  <input
                    value={email}
                    id="email"
                    onChange={handleChangeInput}
                    className="m-4 text-center w-4/6 h-[35px] rounded-lg bg-gray-800 text-white"
                    type="email"
                    name="email"
                    placeholder={t("email")}
                    autoComplete='email'
                  />
                {/* </Fade> */}
                {/* <Fade bottom> */}
                  <input
                    value={password}
                    onChange={handleChangeInput}
                    className="m-4 text-center w-4/6 h-[35px] rounded-lg bg-gray-800 text-white"
                    type="password"
                    name="password"
                    id="password"
                    placeholder={t("password")}
                    autoComplete='password'
                  />
                {/* </Fade> */}
                {/* <Fade top> */}
                  <button type="submit" className="bg-gray-800 textColorR hover:bg-white w-2/6 h-[45px] rounded-md mt-5 mb-5 p-1">{ t("loginBtn")}</button>
                {/* </Fade> */}
                <div className="flex items-center justify-center">
                  {/* <Fade bottom> */}
                    <a href="/forget"><p className="p-2 m-2 mx-1 text-red-600">{ t("forgetpassLink")}</p></a>
                    <a href="/register"><p className="bg-gray-800 text-white textColorR hover:bg-gray-200 w-[90px] h-[35px] text-center rounded-md mt-5 mb-5 p-1">{ t("registerBtn")}</p></a>
                  {/* </Fade> */}
                </div>
              </form>
            {/* </Fade> */}
          </div>
        </div>
      </div>
    </>
  );
}
